// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"680":"1e0e278a","835":"666d78c6"}[chunkId] + ".js";
};